import { createFileRoute, redirect } from '@tanstack/react-router';

import { UserRoles } from '~entities/users/model/types';

import { UpdateAnnouncementPage } from '~features/announcements/ui/update-announcement-page';

import { checkMinRoleValue } from '~shared/utils/role-guard';

export const Route = createFileRoute(
  '/_auth/_layout/announcements/$announcementId/',
)({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.ADMIN);
    if (!hasAccess) {
      return redirect({ to: '/dashboard' });
    }
  },
  component: UpdateAnnouncementPage,
});
